import { Dispatch, FC, SetStateAction } from "react";
import {
    SearchBar,
    SearchBarDataHandler,
} from "../../../assets/components/SearchBar/SearchBar";
import { OptionSearchBarSelectStatus } from "../../../assets/components/SearchBar/SearchBarSelectStatus/helpers";

const IOLO_STATUS_OPTIONS: OptionSearchBarSelectStatus[] = [
    {
        id: 0,
        status: 1,
        name: "Not Activated",
        color: "red",
        checked: true,
    },
    {
        id: 1,
        status: 16,
        name: "Grace period",
        color: "grey",
        checked: true,
    },
    {
        id: 2,
        status: 4,
        name: "Expired",
        color: "yellow",
        checked: true,
    },
];

interface Props {
    dataHandler: Dispatch<SetStateAction<SearchBarDataHandler>>;
}
const IoloLicenseKeysSearchBar: FC<Props> = ({ dataHandler }) => {
    return (
        <SearchBar
            dataHandler={dataHandler}
            statusOptions={IOLO_STATUS_OPTIONS}
            searchInput={{
                placeholder: "License key",
            }}
            searchByOrderId={{
                placeholder: "Order ID",
            }}
            showComponents={{
                selectStatus: true,
                dataPikerDateCreated: true,
                dataPikerNextRebillDate: true,
            }}
        />
    );
};

export default IoloLicenseKeysSearchBar;
